import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import RenderingTile from 'components/molecules/RenderingTile';
import CallOutValueWithChange from 'components/molecules/CallOutValueWithChange';
import CallOutValueWithBoxPlot from 'components/molecules/CallOutValueWithBoxPlot';
import { convertToDisplayValue } from 'helpers/strings';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import { LAYERTHREE } from 'constants/layers';

class ReachModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social`;
        const { actions, campaigns, callouts } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutBucket = convertToDisplayValue(get(callouts, 'params.timeBucket', 'daily'));
        const calloutsData = hasCalloutData ? callouts.data : {};
        const reportingObjective = objective.toLowerCase().replace('_', '-');

        return (
            <ObjectiveVisibilityContainer objective={objective}
                actions={actions} campaigns={campaigns} layer={layer} expandContainer={this.props.ExpandContainer}>
                {/* Call Outs */}
                <Row>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-${reportingObjective}-callouts-mean-reach`}
                                title={`Mean ${calloutBucket} Reach`}
                                type="reach"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_reach_max,
                                    change: Math.round(
                                        calloutsData.reach_mean_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.uniqueSparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithBoxPlot
                                exportName={`${stub}-${reportingObjective}-callouts-median-reach`}
                                title={`Median ${calloutBucket} Reach`}
                                type="reach_median"
                                format='0,0'
                                value={calloutsData.reach_median}
                                boxPlot={{
                                    min: calloutsData.reach_minimum,
                                    q25: calloutsData.reach_q25 || calloutsData.reach_q1,
                                    median: calloutsData.reach_median,
                                    q75: calloutsData.reach_q75 || calloutsData.reach_q3,
                                    max: calloutsData.reach_maximum,
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-${reportingObjective}-callouts-impressions`}
                                title="Impressions"
                                type="impressions"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_impressions,
                                    change: Math.round(
                                        calloutsData.impressions_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                </Row>
            </ObjectiveVisibilityContainer>
        );
    }
}

ReachModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object,
    }).isRequired,
    objective: PropTypes.string.isRequired
};

export default ReachModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/ReachModule.js